import { Button, Badge } from "antd";
import CategoryHeader from "../../components/category/CategoryHeader";
import { formatPrice } from "../../utils/priceFormatter";
import { PRODUCT_ROUTE } from "../../routes/constant";
import { CarOutlined, ClockCircleOutlined } from "@ant-design/icons";

export const TopSellingProducts = ({ products, cityName, isDarkMode, navigate, category }) => {
  if (!products || products.length === 0) return null;

  const topProducts = products.slice(0, 8);


  return (
    <div className={`py-8 ${isDarkMode ? 'bg-gray-900/50' : 'bg-gray-50'}`}>
      <div className="container px-4 mx-auto max-w-7xl">
        <CategoryHeader
          title={`Top Selling ${category} ${cityName ? `in ${cityName}` : ""}`}
          subtitle={`Most demanded smartphones with instant cash value`}
          brandCount={products.length}
          isDarkMode={isDarkMode}
        />

        <div className="mt-4 space-y-3">
          {topProducts.map((product, index) => {
            const price = product.price;
            const brandName = product.brand?.name || "";
            
            return (
              <div
                key={product.id}
                onClick={() => navigate(PRODUCT_ROUTE(product.brand?.category?.slug || product.slug, product.brand?.slug, product.slug))}
                className={`transition-shadow rounded-lg shadow-sm cursor-pointer ${
                  isDarkMode ? 'bg-gray-800 border-gray-700 hover:shadow-md' : 'bg-white border border-gray-100 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3 p-3">
                  {/* Rank */}
                  <div className="flex-shrink-0 w-8 text-center">
                    <span className={`text-lg font-bold ${
                      index === 0 ? 'text-yellow-500' :
                      index === 1 ? 'text-gray-400' :
                      index === 2 ? 'text-orange-500' :
                      isDarkMode ? 'text-gray-600' : 'text-gray-300'
                    }`}>
                      #{index + 1}
                    </span>
                    {index === 0 && (
                      <div className="text-[10px] text-yellow-500">🔥</div>
                    )}
                  </div>

                  {/* Product Image */}
                  <div className={`flex items-center justify-center w-16 h-16 p-1.5 rounded-lg flex-shrink-0 ${
                    isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
                  }`}>
                    <img
                      src={product.image}
                      alt={product.title}
                      className="object-contain w-full h-full"
                    />
                  </div>

                  {/* Product Info - Close to image */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className={`text-sm font-semibold line-clamp-1 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                        {product.title}
                      </h3>
                    </div>
                    
                    <div className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                      {brandName}
                    </div>

                    <div className="flex flex-wrap items-center gap-2 mt-0.5">
                      <Badge 
                        count="Verified" 
                        style={{ 
                          backgroundColor: "#22c55e", 
                          fontSize: "8px",
                          borderRadius: "5px",
                          padding: "0 6px",
                          height: "16px",
                          lineHeight: "16px",
                        }}
                        className="text-[8px]"
                      />
                      <div className="flex items-center gap-0.5">
                        <ClockCircleOutlined className={`text-[10px] ${isDarkMode ? 'text-green-400' : 'text-green-500'}`} />
                        <span className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Instant</span>
                      </div>
                      <div className="flex items-center gap-0.5">
                        <CarOutlined className={`text-[10px] ${isDarkMode ? 'text-blue-400' : 'text-blue-500'}`} />
                        <span className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Free</span>
                      </div>
                    </div>
                  </div>

                  {/* Price & CTA */}
                  <div className="flex-shrink-0 text-right">
                    <div className="text-sm font-bold text-green-600">
                      {formatPrice(price)}
                    </div>
                    <Button
                      type="primary"
                      size="small"
                      className="px-3 mt-0.5 text-xs bg-green-600 border-green-600 hover:bg-green-700 h-7 rounded-[5px]"
                    >
                      Sell Now
                    </Button>
                  </div>
                </div>
                
                {/* Popularity Bar */}
                <div className={`h-0.5 rounded-full overflow-hidden ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                  <div 
                    className="h-full transition-all duration-500 rounded-full bg-gradient-to-r from-green-500 to-green-400"
                    style={{ width: `${Math.max(100 - (index * 8), 30)}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};